import { Github, Download, ExternalLink } from 'lucide-react';
import { Button } from './ui/Button';
import './Footer.css';

const GITHUB_REPO = 'https://github.com/IntelligentElectron/universal-netlist';
const GITHUB_RELEASES = `${GITHUB_REPO}/releases`;

/** Diode schematic symbol icon. */
function DiodeIcon({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <line x1="2" y1="12" x2="7" y2="12" />
      <polygon points="7,6 7,18 17,12" fill="currentColor" stroke="none" />
      <line x1="17" y1="6" x2="17" y2="18" />
      <line x1="17" y1="12" x2="22" y2="12" />
    </svg>
  );
}

/**
 * Footer with final CTA and links.
 */
export function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        {/* Final CTA */}
        <div className="footer-cta">
          <div className="footer-cta-icon">
            <DiodeIcon size={48} />
          </div>
          <h2 className="footer-cta-title">Ready to Get Started?</h2>
          <p className="footer-cta-description">
            Download Intelligent Electron and start querying circuits with AI.
          </p>
          <div className="footer-cta-actions">
            <Button
              variant="primary"
              size="lg"
              icon={<Download size={20} />}
              href={GITHUB_RELEASES}
            >
              Download on GitHub
            </Button>
            <Button
              variant="secondary"
              size="lg"
              icon={<ExternalLink size={18} />}
              href={`${GITHUB_REPO}#readme`}
            >
              View Documentation
            </Button>
          </div>
        </div>

        {/* Links */}
        <div className="footer-bottom">
          <div className="footer-brand">
            <DiodeIcon size={20} className="footer-brand-icon" />
            <span className="footer-brand-text">Intelligent Electron</span>
          </div>

          <div className="footer-links">
            <a href={GITHUB_REPO} className="footer-link" target="_blank" rel="noopener noreferrer">
              <Github size={16} />
              <span>GitHub</span>
            </a>
          </div>

          <p className="footer-copyright">Built for hardware engineers</p>
        </div>
      </div>
    </footer>
  );
}
